<template>
  <div class='swiper-container' @mouseover="mouseOver"  @mouseleave="mouseLeave">
    <el-carousel ref="elCarousel" :interval="2000" height="490px" :autoplay="autoplay" indicator-position="none"  :arrow="arrow">
      <el-carousel-item v-for="(item, k) in childData" :key="k">
        <img :src="item.tnUrl" alt="">
        <p class="carousel-pagination">{{(k+1)}} / {{childData.length}}</p>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
// 引入插件
export default {
  props: ["childData","swiperOption"],

  data () {
    return {
      autoplay: false,
      arrow: 'never'
    }
  },


  components: {
   
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    mouseOver () {
      this.$refs.elCarousel.handleMouseEnter = () => { 
        this.autoplay = true
        this.arrow = 'always'
      };
    },
    mouseLeave () {
      this.autoplay = false
      this.arrow = 'never'
    }

  }
}
</script>
<style  scoped >
.swiper-container {
  width: 610px;
  height: 490px;
}
.el-carousel__item {
  width: 100%;
  height: 100%;
}
.el-carousel__item img{
  width: 100%;
  height: 100%;
  object-fit:cover;
  transition: all 0.3s;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

}
.carousel-pagination {
  color: #FFF;
  font-size: 14px;
  height: 50px;
  width: 100%;
  line-height: 50px;
  text-align: center;
  position: absolute;
  bottom: 0;
  transition: opacity .3s;
  transform: translateZ(0); 
}
.el-carousel__item:hover .carousel-pagination{
  /* color: #d4011a; */
}
</style>


// WEBPACK FOOTER //
// src/components/swiper/othersPhotoShow.vue